import { useEffect, RefObject } from "react";

export function useInfiniteScroll(
  sentinelRef: RefObject<HTMLElement>,
  fetchNextPage: () => void,
  hasNextPage: boolean,
  loading: boolean
) {
  useEffect(() => {
    if (!sentinelRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting && hasNextPage && !loading) {
          fetchNextPage();
        }
      },
      { threshold: 1 }
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, [sentinelRef, fetchNextPage, hasNextPage, loading]);
}
